export default __webpack_public_path__ + "static/media/er4.0cf74100.png";